import React from 'react';
import { ListColumn } from '../Datalist/Datalist';
import Datalist from '../Datalist/Datalist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons'; // Import the necessary icons
import './PdfTable.scss';

interface PdfTableProps {
    invoiceList: {
        pdfName: string;
        status?: number; // Status for processed or pending
        invoiceNumber?: string;
        billingDate?: string;
        totalPrice?: number;
        sinfraAvtal?: number;
    }[]; // Array of PDF objects with additional fields
    onInvoiceClick: (fileName: string) => void; // Callback to handle file click
}

const PdfTable: React.FC<PdfTableProps> = ({ invoiceList, onInvoiceClick }) => {

    // Define columns for the PdfTable
    const columns: ListColumn<any>[] = [
        {
            key: 'pdfName',
            fieldName: 'pdfName',
            name: 'PDF-filnamn', // PDF File Name
            maxWidth: '100%',
            minWidth: 150,
            isActive: true,
            onRender: (item) => (
                <div
                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => onInvoiceClick(item.pdfName)} // Ensure we're passing the correct value (pdfName)
                >
                    <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '8px', color: 'red' }} />
                    <span className="pdf-file-name">{item.pdfName}</span> {/* Ensure this is a string */}
                </div>
            ),
            footer: (items) => `Totalt antal rader: ${items.length}`,
        },
        {
            key: 'status',
            fieldName: 'status',
            name: 'Behandlad', // Processed status in Swedish
            minWidth: 100,
            isActive: true,
            onRender: (item) => (
                <div>
                    {item.status === 1 ? (
                        <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} /> // Processed
                    ) : (
                        <FontAwesomeIcon icon={faClock} style={{ color: 'orange' }} /> // Waiting for process
                    )}
                </div>
            ),
        },

        {
            key: 'invoiceNumber',
            fieldName: 'invoiceNumber',
            name: 'Fakturanummer', // Invoice Number
            minWidth: 150,
            isActive: true,
            onRender: (item) => <span>{item.invoiceNumber || 'N/A'}</span>, // Add fallback for empty fields
        },
        {
            key: 'billingDate',
            fieldName: 'billingDate',
            name: 'Fakturadatum', // Billing Date
            minWidth: 150,
            isActive: true,
            onRender: (item) => (
                <span>{item.billingDate ? new Date(item.billingDate).toLocaleDateString() : 'N/A'}</span> // Ensure a string is returned
            ),
        },
        {
            key: 'totalPrice',
            fieldName: 'totalPrice',
            name: 'Totalpris', // Total Price
            minWidth: 150,
            isActive: true,
            onRender: (item) => <span>{item.totalPrice ? item.totalPrice.toFixed(2) : 'N/A'}</span>, // Ensure a string or number is returned
        },
        {
            key: 'sinfraAvtal',
            fieldName: 'sinfraAvtal',
            name: 'SinfraAvtal', // Sinfra Agreement
            minWidth: 150,
            isActive: true,
            onRender: (item) => <span>{item.sinfraAvtal || 'N/A'}</span>, // Ensure a string or number is returned
        },
    ];

    return (
        <Datalist
            items={invoiceList}
            isLoading={false} // No loading state for this component
            columns={columns}
            setColumns={() => { }} // No need to dynamically set columns here
            initialSortKey="pdfName"
            descendingSort={false}
            noItemsText="Inga fakturor att visa"
            uniqueKey="pdfName" // Use file name as the unique key
        />
    );
};

export default PdfTable;
